import { useSuspenseQuery } from '@tanstack/react-query';

import { StationDetailContent } from '@/components/map/details/content/StationDetailContent';
import { DetailPopup } from '@/components/map/details/popup/DetailPopup';
import { backendApiStationsFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';
import { FeatureType } from '@/types/FeatureType';
import { getMapLayer } from '@/utils/getMapLayer';

interface StationPopupProps {
  id: string;
}

export function StationPopup({ id }: StationPopupProps) {
  const { data: station } = useSuspenseQuery({
    ...backendApiStationsFindOneOptions({
      path: { stationId: id },
      query: { parkAndRideFacilities: true, parkAndRideFacilitiesPublication: true },
    }),
  });

  if (!station.geometry) {
    return null;
  }

  return (
    <DetailPopup
      id={id}
      mapLayer={getMapLayer(station)}
      point={station.geometry}
      title={station.name}
      type={FeatureType.STATION}
    >
      <StationDetailContent station={station} />
    </DetailPopup>
  );
}
